export enum Priorities {
  low = 'low',
  medium = 'medium',
  high = 'high',
}
